import { Image } from 'components/common';
import Logo from 'components/common/Logo';
import { PerkAsset } from './types';

interface PerkBannerProps {
  banners: PerkAsset[];
  logo: PerkAsset | null;
  onBannerClick?: () => void;
}

export const PerkBanner = ({
  banners,
  logo,
  onBannerClick,
}: PerkBannerProps) => {
  const banner = banners?.[0];

  return (
    <figure className="tw-relative tw-block tw-bg-transparent tw-mb-0 tw-overflow-hidden before:tw-content-[''] before:tw-block before:tw-w-full before:tw-bg-[linear-gradient(#f4f4f4_250px,transparent_0)] before:tw-bg-cover before:tw-bg-center before:tw-aspect-video before:tw-bg-gray-100">
      <div
        className="tw-absolute tw-inset-0 tw-cursor-pointer"
        onClick={onBannerClick}
      >
        {banner && (
          <Image
            src={banner.asset.url}
            alt="Perk Banner"
            width={800}
            height={450}
            layout="responsive"
            objectFit="cover"
          />
        )}
      </div>
      <div className="tw-absolute tw-top-5 tw-left-5 tw-w-16 tw-h-16 tw-rounded-full">
        <div className="tw-relative tw-aspect-square">
          {logo ? (
            <Image
              src={logo.asset.url}
              alt="Perk Banner"
              width={128}
              height={128}
              layout="responsive"
              objectFit="cover"
              className="tw-rounded-full tw-shadow"
            />
          ) : (
            <div className="tw-w-16 tw-h-16 tw-rounded-full tw-bg-primary tw-flex tw-items-center tw-justify-center">
              <Logo variant="logomark" theme="dark" size={4} />
            </div>
          )}
        </div>
      </div>
    </figure>
  );
};
